import React from 'react'
import HeaderWmo from './HeaderWmo'

const Header = props => {
  const {
    originalDynamicApiData,
  } = props

  const { pageType = '' } = originalDynamicApiData || {}

  return <HeaderWmo pageType={pageType} />
}

export default Header
